export const getQueryParams = (data?: Object) => {
  if (data == null) return "";
  const params: string[] = [];

  // Iterate over the object's own enumerable properties
  for (const [key, value] of Object.entries(data)) {
    // Skip empty keys or properties with null/undefined values
    if (key !== "" && value !== null && value !== undefined && value != "") {
      if (Array.isArray(value)) {
        // Handle arrays by repeating the key for each element
        value.forEach((item) => {
          params.push(
            `${encodeURIComponent(key)}=${encodeURIComponent(String(item))}`
          );
        });
      } else {
        // Handle single values by converting to string and encoding
        params.push(
          `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
        );
      }
    }
  }

  // Join all key=value pairs with '&' and return the result
  return params.join("&");
};

// export const getQueryParams = (data: unknown) => {
//   return new URLSearchParams(
//     data as unknown as Record<string, string>
//   ).toString();
